import { message } from './../../../../../core/manage/_models/message';
import { async } from '@angular/core/testing';
import { ChangeDetectorRef, OnDestroy, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// import { CameraOpenStream } from '@core/manage/_models/camera-open-stream';
import { CameraService } from '@core/manage/_services/camera.service';
import { finalize, tap, takeUntil } from 'rxjs/operators';
// import videojs from 'video.js';
import { Subject } from 'rxjs';
import DPlayer from 'dplayer';
import { ToastService } from '@core/_base/layout';
import { TranslateService } from '@ngx-translate/core';
import { DPlayerService } from 'angular-dplayer';
declare var require: any;
// require('videojs-contrib-quality-levels');
// require('videojs-hls-quality-selector');
@Component({
	selector: 'kt-tracking-camera-stream-popup',
	templateUrl: './tracking-camera-stream-popup.component.html',
	styleUrls: ['./tracking-camera-stream-popup.component.scss'],
})
export class TrackingCameraStreamPopupComponent implements OnInit, OnDestroy, AfterViewChecked {
	@Input() imei: string;
	@Input() id: string;
	@Input() userId: string;
	@Input() message: string;
	@Input() icon: string;
	@Input() type: string;
	@Input() size: string;


	public styleIcon: object;
	public showSpinner = false;
	public isOffline = false;
	private dataCameraSize;
	public dataCamera: any = [];
	playerList: any = [];
	private unsubscribe: Subject<any>;
	public responseStatus = false;
	public timeOutStream = false;
	constructor(private cameraService: CameraService, public sanitizer: DomSanitizer, private cdr: ChangeDetectorRef, private DPService: DPlayerService) {
		this.unsubscribe = new Subject();
		if (!this.icon) this.icon = 'icon-search';
		if (!this.message) this.message = 'COMMON.MESSAGE.NOT_FOUND_DATA';
		if (!this.size) this.size = 'md';
		this.styleIcon = { 'font-size': '2.4rem' };
	}

	ngOnDestroy(): void {}

	myVideo: string = 'my-video';
	url = 'https://www.evbig.com:443/playback/video/c48f050e-5892-455b-99c0-5a9025adb8e7/playlist.m3u8';

	loadData() {
		this.showSpinner = true;
		setTimeout(() => {
			this.showSpinner = false;
		}, 3000);
	}

	public initVideo = 0;
	// ngAfterViewChecked() {

	// }

	ngOnInit() {
		this.getCamera();
		this.loadData();
		// clearTimeout(this.action);
	}

	public link: string = 'https://wcs5-eu.flashphoner.com:8888/embed_player?urlServer=wss://wcs5-eu.flashphoner.com:8443&streamName={link}&mediaProviders=WebRTC,Flash,MSE,WSPlayer';
	num: number = 0;
	flv: any = [];
	public filter: any;
	async getCamera() {
		let params = {
			pageNo: 1,
			pageSize: 10,
			deviceId: this.id,
		};
		await this.cameraService
			.listUrlStream({ params })
			.pipe(
				tap((data) => {
					console.log(data);

					if (data.status == 200) {

						if (data.result.status == 200) {
							this.dataCamera = data.result.content.map((i) => {
								// i.streamUrl = this.url;
								// i.idVideo = 'my-video' + this.num++;
								return i;
							});
							this.showSpinner = false;
							this.responseStatus = false;
						} else {
							this.message = 'STREAMAX.STATUS_RESPONSE.' + data.result.messageCode;
							this.responseStatus = true;
							this.showSpinner = false;
						}
					} else {
						this.showSpinner = false;
						this.message = 'COMMON.MESSAGE.NOT_FOUND_DATA';
						this.responseStatus = true;
					}
				}),

				finalize(this.cdr.markForCheck)
			)
			.toPromise();
	}
	action = setTimeout(() => {
		this.timeOutStream = true;
	}, 5000);
	over() {
		// clearTimeout(this.action);
		// this.timeOutStream = false;
		// this.action = setTimeout(() => {
		// 	this.timeOutStream = true;
		// }, 180000);
	}

	ngAfterViewChecked() {
		// if (this.timeOutStream == true) {
		// 	this.dataCamera = [];
		// 	this.message = 'COMMON.MESSAGE.PLEASE_SELECT_DEVICE_TO_VIEW_AGAIN';
		// 	this.responseStatus = true;
		// }
	}

	// out(){
	// 	console.log("mouse out")
	// }
}
